import { jsx, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import { c as classNames, d as EGDSContextProvider, u as useEGDSContext } from '../theme-provider/index-chunk.esm.js';
import styles from '../styles/uitk-egds-form.css';
const getClassNameList$1 = classNames.bind(styles);
const useFormCallback = (name, transformer) => {
  const {
    data: contextData
  } = useEGDSContext();
  const {
    fieldChangeCallback
  } = contextData ?? {};
  // If (!fieldChangeCallback) {
  //   throw new Error(
  //     'fieldChangeCallback prop should be set in any UitkForm in the parent tree of a field using this hook'
  //   );
  // }
  return React.useCallback(event => {
    const transformedEvent = transformer(event);
    const {
      value = '',
      id = ''
    } = transformedEvent.currentTarget;
    fieldChangeCallback?.({
      name,
      value,
      id
    }, transformedEvent);
    return transformedEvent;
  }, [name, transformer, fieldChangeCallback]);
};
const EGDSForm = React.forwardRef((props, ref) => {
  const {
    hasRequiredFieldIndicator,
    children,
    className,
    onFieldChange,
    ...formProps
  } = props;
  const baseClass = 'uitk-form';
  const wrapperClassNames = getClassNameList$1(baseClass, {
    'has-required-indicator': hasRequiredFieldIndicator
  }, className);
  const contextData = {
    hasRequiredFieldIndicator,
    fieldChangeCallback: onFieldChange
  };
  return jsx(EGDSContextProvider, {
    config: {
      context: 'uitk-form-context',
      data: contextData
    },
    children: jsx("form", {
      ref: ref,
      ...formProps,
      className: wrapperClassNames,
      children: children
    })
  });
});
EGDSForm.displayName = 'EGDSForm';
const getClassNameList = classNames.bind(styles);
const EGDSGroupedFields = props => {
  const {
    children,
    className,
    label,
    hasRequiredGroupFieldIndicator,
    ...fieldSetProps
  } = props;
  const baseClass = 'uitk-form-grouped-fields';
  const {
    data: contextData
  } = useEGDSContext();
  const {
    hasRequiredFieldIndicator
  } = contextData ?? {};
  const wrapperClassNames = getClassNameList(baseClass, className);
  const legendClassName = getClassNameList(`${baseClass}-label`);
  let legend = jsxs("legend", {
    className: legendClassName,
    children: [label, hasRequiredFieldIndicator && hasRequiredGroupFieldIndicator && jsx("span", {
      "aria-hidden": "true",
      className: getClassNameList('uitk-form-grouped-fields-required-asterisk'),
      children: "*"
    })]
  });
  if (React.isValidElement(label)) {
    const labelText = React.Children.toArray(label.props.children).reduce((accumulator, child) => {
      if (typeof child === 'string') {
        accumulator.push(child);
      } else if (typeof child === 'object') {
        accumulator.push(child.props.children);
      }
      return accumulator.join('');
    }, []);
    legend = React.cloneElement(label, {}, jsxs("legend", {
      className: legendClassName,
      children: [labelText, hasRequiredFieldIndicator && hasRequiredGroupFieldIndicator && jsx("span", {
        "aria-hidden": "true",
        className: getClassNameList('uitk-form-grouped-fields-required-asterisk'),
        children: "*"
      })]
    }));
  }
  return jsx(EGDSContextProvider, {
    config: {
      context: 'uitk-grouped-fields-context',
      data: {
        hasRequiredFieldIndicator: hasRequiredFieldIndicator && !hasRequiredGroupFieldIndicator
      }
    },
    children: jsxs("fieldset", {
      ...fieldSetProps,
      className: wrapperClassNames,
      children: [legend, children]
    })
  });
};
EGDSGroupedFields.displayName = 'EGDSGroupedFields';
export { EGDSForm as E, EGDSGroupedFields as a, useFormCallback as u };